<template>
  <v-card align="center" justify="center" light min-width="20vw" outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action><v-icon class="icon" icon @click="closeWindow">fa-times</v-icon></v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <p><b>{{ $t('subtitle') }}</b></p>
      <p>{{ $t('descriptionPrepend') }} (<a href="mailto:aj@swiset.com" target="_blank">aj@swiset.com</a>)
        <br>{{ $t('descriptionAppend') }}
      </p>
      <v-btn @click="closeWindow">{{ $t('btnClose') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "TournamentContactUs",
  methods: {
    closeWindow() {
      this.$emit('closeWindow');
    },
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Create a Tournament",
    "subtitle": "We are so happy to host your tournament!",
    "descriptionPrepend": "Please sent an email to us",
    "descriptionAppend": "with your name and requirements.",
    "btnClose": "Close"
  },
  "es": {
    "title": "Crea un Torneo",
    "subtitle": "¡Estaremos muy felices de alojar tu torneo!",
    "descriptionPrepend": "Por favor envíanos un correo a",
    "descriptionAppend": "con tu nombre y tus requerimientos.",
    "btnClose": "Cerrar"
  }
}
</i18n>

<style scoped>

</style>
